var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3376",
  "data-name": "Group 3376",
  transform: "translate(-24 -23)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
  transform: "translate(24 23)",
  fill: "#eddd21"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3374",
  "data-name": "Group 3374",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M209.687,149.976v8",
  transform: "translate(-173.187 -121.976)",
  fill: "none",
  stroke: "#212121",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(35 38)",
  fill: "#212121"
})))));
export default __webpack_public_path__ + "static/media/yellow-i.d4931d41.svg";
export { SvgComponent as ReactComponent };